import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../types/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Considera "frescos" los datos durante 5 min (no refetch al montar)
      staleTime: 5 * 60 * 1000,
      // Tiempo que se mantienen en caché
      gcTime: 30 * 60 * 1000,
      // Evita refetch al volver a enfocar la pestaña
      refetchOnWindowFocus: false,
      // Reintenta una vez si falla (salvo errores controlados por ApiError con status 401/403/422)
      retry: (failureCount: number, error: unknown) => {
        if (error instanceof ApiError) {
          const s = error.status;
          if (s === 401 || s === 403 || s === 422) return false;
        }
        // reintentar hasta 1 vez para otros errores
        return failureCount < 1;
      },
    },
  },
});
